import React, { useEffect, useState } from "react";
import cardsBg from "assets/images/common/others/cardsBg.png";
import useUsers from "containers/user-management/useHooks";
import { BAGDE_TYPES } from "utils/helpers/enums/shared.enum";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";

interface Props {
  minorId: number;
}

const TAB_ACHIEVEMENTS = "Learn Local’s Badges";
const TAB_EVENTS = "Event Badges";

const DigitalPassport = ({ minorId }: Props) => {
  const { getUserBadges } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [achievements, setAchievements] = useState<any[]>([]);
  const [events, setEvents] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>(TAB_ACHIEVEMENTS);

  const [achievementPage, setAchievementPage] = useState(0);
  const [achievementHasMore, setAchievementHasMore] = useState(true);

  const [eventPage, setEventPage] = useState(0);
  const [eventHasMore, setEventHasMore] = useState(true);


  const loadBadges = async (badgeType: BAGDE_TYPES, page: number = 0) => {
    const isAchievement = badgeType === BAGDE_TYPES.ACHIEVEMENT;
    const setData = isAchievement ? setAchievements : setEvents;
    const setHasMore = isAchievement ? setAchievementHasMore : setEventHasMore;

    await getUserBadges(setData, {
      page,
      size: 4,
      badgeType,
      userId: minorId,
    }, page, setHasMore);

    // Update page state
    if (isAchievement) {
      setAchievementPage(page + 1);
    } else {
      setEventPage(page + 1);
    }
  };


  const handleLoadMore = () => {
    const isAchievement = activeTab === TAB_ACHIEVEMENTS;
    const nextPage = isAchievement ? achievementPage : eventPage;
    loadBadges(isAchievement ? BAGDE_TYPES.ACHIEVEMENT : BAGDE_TYPES.EVENT, nextPage);
  };


  useEffect(() => {
    if (activeTab === TAB_ACHIEVEMENTS && achievements.length === 0) {
      loadBadges(BAGDE_TYPES.ACHIEVEMENT);
    }
    if (activeTab === TAB_EVENTS && events.length === 0) {
      loadBadges(BAGDE_TYPES.EVENT);
    }
  }, [activeTab]);

  const currentList = activeTab === TAB_ACHIEVEMENTS ? achievements : events;

  return (
    <div>
      <div className="flex justify-start mb-6">
        {[TAB_ACHIEVEMENTS, TAB_EVENTS].map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 text-xs font-semibold ${activeTab === tab
              ? "text-lightBlueColor border-b-2 border-lightBlueColor"
              : "text-mediumGrayText"
              }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-4 py-2">
        {currentList.map((badge, index) => (
          <div
            key={badge?.id || `badge-${index}`}
            className="flex flex-col items-center justify-center border border-borderLightGray p-3 rounded-lg w-[235px] h-[260px]"
            style={{ backgroundImage: `url(${cardsBg})` }}
          >
            <div className="hover:scale-110 transition-transform duration-300">
              <img
                className="w-[165px] h-[177px]"
                src={
                  badge?.image
                    ? concatPathWithBackendUrl(badge?.image?.name)
                    : editProfilePicUser
                }
              />
            </div>
            <span className="text-sm font-medium text-primaryText mt-3">
              {badge?.name || "--"}
            </span>
          </div>
        ))}


      </div>
      {(activeTab === TAB_ACHIEVEMENTS ? achievementHasMore : eventHasMore) && (
        <div className="flex justify-center mt-4">
          <button
            onClick={handleLoadMore}
            className="px-4 py-2 text-sm font-semibold text-white bg-lightBlueColor rounded"
          >
            See More
          </button>
        </div>
      )}

      <div className="">
        <DataNotFound show={!isLoading && !currentList.length} />
      </div>
    </div>
  );
};

export default DigitalPassport;
